<div class="d-flex w-100">
  <div class="col-12 col-md-8 col-lg-7 left-container">
    <h3 class="m-0">{{ "OTP Code" | translate }}</h3>
    <p class="mt-5">
      {{ "Enter the six digit code we send to" | translate }}
      <span class="bold-text">{{ "beshobassem@gmail.com" }}</span>
    </p>
    <label>{{ "OTP Code" | translate }}</label>
    <div class="d-flex gap-3">
      <input
        #otpInput
        type="number"
        class="otp-input"
        *ngFor="let otp of otpArray; let i = index"
        [(ngModel)]="otpValues[i]"
        (input)="onInput($event, i)"
        maxlength="1"
      />
    </div>
    <div class="mt-4">
      {{ "Didn’t got the code?" | translate }}
      <span class="bold-text">{{ "Resend" | translate }}</span>
    </div>
    <button class="w-100 btn" [routerLink]="'/' + lang + '/resetPassword'">
      {{ "Verify" | translate }}
    </button>

    <div class="or-divider mt-4">
      <div class="line"></div>
      <label>{{ "Or" | translate }}</label>
      <div class="line"></div>
    </div>
    <div class="social mt-4">
      <button>
        <img src="../../../../assets/img/google.svg" />
        {{ "Signup with Google" | translate }}
      </button>
    </div>

    <div class="text-center mt-4">
      {{ "Login with another account?" | translate }}
      <span class="bold-text" [routerLink]="'/' + lang + '/login'">{{
        "Login" | translate
      }}</span>
    </div>
  </div>

  <div class="d-none d-md-block col-md-4 col-lg-5 right-container">
    <img width="50%" [src]="logo" />
  </div>
</div>
